/**
 * Origem dos diálogos que a leitura de um QR code enfileira.
 *
 * Os dois leitores (`BottomNavQrCodeReader` e `QRCodesWatcher`) limpam o que a
 * leitura anterior deixou pendente antes de começar a próxima. Sem esta marca,
 * a limpeza levaria junto diálogo de fluxo alheio — inclusive um `confirm`
 * aberto, que seria respondido por engano.
 */
export const QR_READING_DIALOG_SOURCE = 'qr-reading'
